import React, { useCallback } from 'react';
import PerformanceMark from '@atlassian/jira-common-performance/src/set-performance-mark.tsx';
import {
	PAGE_LAYOUT_MARK,
	PAGE_CONTAINER_END_MARK,
	GLOBAL_CONTAINERS_END_MARK,
} from '@atlassian/jira-page-container-constants/src/index.tsx';
import { setInitialPageLoadTimingFromPerformanceMarks } from '@atlassian/jira-spa-performance-breakdown/src/utils/performance-marks-tools/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useFaviconService } from '@atlassian/jira-favicon/src/index.tsx';
import { PageContainer } from '../../common/ui/page-container/main.tsx';
import { Content } from './content/index.tsx';
import type { SpaProps } from './types.tsx';

export const Spa = ({
	baseUrl,
	locale,
	messages,
	isPrewarming = false,
	Router,
	routes,
	routerLinkComponent,
	initRoute,
}: SpaProps) => {
	const pageContainerPerformanceTiming = useCallback(() => {
		setInitialPageLoadTimingFromPerformanceMarks(
			PAGE_LAYOUT_MARK,
			GLOBAL_CONTAINERS_END_MARK,
			PAGE_CONTAINER_END_MARK,
			true,
			true,
		);
	}, []);

	const FaviconService = () => {
		useFaviconService();

		return null;
	};

	return (
		<PageContainer
			baseUrl={baseUrl}
			id={__SERVER__ ? 'jira.entry.ssr' : 'spa'}
			locale={locale}
			messages={messages}
			Router={Router}
			routerLinkComponent={routerLinkComponent}
		>
			{fg('blu-7193-new-jira-favicons') && <FaviconService />}
			<PerformanceMark metricKey={PAGE_CONTAINER_END_MARK} onSet={pageContainerPerformanceTiming} />
			{isPrewarming !== true && <Content initRoute={initRoute} routes={routes} />}
		</PageContainer>
	);
};
